import { Text, View, Image, Platform } from 'react-native';
import Typography from '../../sharedComponents/typography/Typography';
import { ThemedText, ThemedView } from '../../theme';
import { FontFamilyTokens, FontSizeTokens } from '@voltmoney/schema';

export const MANAGE_LIMIT =
  'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Empty_Limit.png';

function ManageLimit() {
  return (
    <ThemedView bg='bg-surface-primary' flex={1}>
       <ThemedView mb='3xl'  padding='lg' pt='xl' borderBottomWidth={1} borderBottomColor='border-secondary'>
          <Typography
            label={'Manage Limit'}
            fontFamily={FontFamilyTokens.Poppins}
            fontSize={FontSizeTokens.MD}
            fontWeight='600'
            lineHeight={24}
          />
        </ThemedView>
      <ThemedView
        mt='5xl'
        justifyContent='center'
        alignItems='center'
        mx="5xl"
        >
        <Image
          source={{ uri: MANAGE_LIMIT }}
          style={{
            height: Platform.OS !== 'web' ? 250 : 200,
            width: Platform.OS !== 'web' ? '100%' : 200,
          }}
          resizeMode={'contain'}
        />
        <ThemedText variant='b2s' color='text-secondary' textAlign='center' mt='5xl'>
        You can manage your credit limit, and mark or unmark your funds from
        here after you start your credit limit
        </ThemedText>
      </ThemedView>
    </ThemedView>
  );
}

export default ManageLimit;
